module.exports = __webpack_public_path__ + "img/save-icon.d619b315.svg";